// ─────────────────────────────────────────────
// HubWire Email Service
// Currently: stub functions that log to console
// Later: replace with Resend API calls via
// Cloudflare Workers (POST /api/email/send)
// ─────────────────────────────────────────────

import type { Registration, ContactFormData, Announcement } from '../../types';

// ─────────────────────────────────────────────
// Registration Confirmation to Registrant
// ─────────────────────────────────────────────
export async function sendRegistrationConfirmation(
  registration: Registration
): Promise<void> {
  // TODO: Replace with Resend API call
  // POST https://api.resend.com/emails
  // Template: registration-confirmation
  console.log('[EmailService] Registration confirmation stub:', {
    to: registration.email,
    subject: 'Your registration is confirmed',
    registration_id: registration.id,
    event_id: registration.event_id,
  });
}

// ─────────────────────────────────────────────
// New Registration Notification to Admin
// ─────────────────────────────────────────────
export async function sendAdminRegistrationNotification(
  registration: Registration
): Promise<void> {
  // TODO: Replace with Resend API call
  // Template: admin-new-registration
  console.log('[EmailService] Admin registration notification stub:', {
    to: 'admin@organization.ca',
    subject: `New registration: ${registration.name}`,
    registration_id: registration.id,
  });
}

// ─────────────────────────────────────────────
// Contact Form Notification to Admin
// ─────────────────────────────────────────────
export async function sendContactFormNotification(
  formData: ContactFormData
): Promise<void> {
  // TODO: Replace with Resend API call
  // Template: contact-form-notification
  console.log('[EmailService] Contact form notification stub:', {
    to: 'admin@organization.ca',
    subject: `New contact form message from ${formData.name}`,
    from_name: formData.name,
    from_email: formData.email,
  });
}

// ─────────────────────────────────────────────
// Announcement Notification (future broadcast)
// ─────────────────────────────────────────────
export async function sendAnnouncementNotification(
  announcement: Announcement,
  recipientEmails: string[]
): Promise<void> {
  // TODO: Replace with Resend batch send API call
  // Template: announcement-notification
  console.log('[EmailService] Announcement notification stub:', {
    to: recipientEmails,
    subject: `New announcement: ${announcement.title}`,
    announcement_id: announcement.id,
  });
}
